
// Generate a referral code for a user
export const generateReferralCode = (userId: string): string => {
  // Simple implementation that combines user ID with random characters
  const randomPart = Math.random().toString(36).substring(2, 6).toUpperCase();
  const userPart = userId.substring(0, 4).toUpperCase();
  return `${userPart}${randomPart}`;
};

// Get a user's referral code by email
export const getUserReferralCodeByEmail = async (
  email: string,
  userId?: string
): Promise<string> => {
  // In a real app, this would query a database
  console.log(`Getting referral code for ${email}`);
  
  // Generate a deterministic code based on email
  const emailHash = hashString(email);
  const code = emailHash.substring(0, 6).toUpperCase();
  
  return `REF${code}`;
};

// Simple string hash function
const hashString = (str: string): string => {
  let hash = 0;
  if (str.length === 0) return hash.toString();
  
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Convert to positive hex string
  return Math.abs(hash).toString(16);
};
